import React, { Component } from 'react';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Navigation from "context/nav";
import './settings.css';

import Profile from "./profile";
import Access from "components/profile/access";
import ApiKeys from "components/profile/apiKeys";
import Limits from "components/profile/limits";
import Credentials from "components/profile/credentials";
import PreferencesEditor from "components/profile/preferences";
import Admin from "./admin";

export default class BlobSettings extends Component {
  render() {
    if ( !this.props.org || !this.props.blob ) {
      return (<></>);
    }

    const sectionId = this.props.match.params.sectionId || "profile";
    const canAdmin = this.props.app.api.isBlobSettingsAccessible(this.props.blob);

    return (
      <>
        <Container className="blob-header-row content-row">
          <Row>
            <Col sm={3}>
              <Card>
                <ListGroup variant="flush" className="blob-settings-navigation-list">
                  {"profile" === sectionId
                    ? <ListGroup.Item active>Profile</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsProfilePath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>Profile</ListGroup.Item>
                      </Link>
                  }
                  {canAdmin && ("access" === sectionId
                    ? <ListGroup.Item active>Access</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsAccessPath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>Access</ListGroup.Item>
                      </Link>
                  )}
                  {canAdmin && ("api-keys" === sectionId
                    ? <ListGroup.Item active>API Keys</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsApiKeysPath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>API Keys</ListGroup.Item>
                      </Link>
                  )}
                  {canAdmin && ("credentials" === sectionId
                    ? <ListGroup.Item active>Credentials</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsCredentialsPath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>Credentials</ListGroup.Item>
                      </Link>
                  )}
                  {canAdmin && ("limits" === sectionId
                    ? <ListGroup.Item active>Limits</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsLimitsPath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>Limits</ListGroup.Item>
                      </Link>
                  )}
                  {"preferences" === sectionId
                    ? <ListGroup.Item active>Preferences</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsPreferencesPath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>Preferences</ListGroup.Item>
                      </Link>
                  }
                  {canAdmin && ("admin" === sectionId
                    ? <ListGroup.Item active>Administration</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsAdminPath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>Administration</ListGroup.Item>
                      </Link>
                  )}
                </ListGroup>
              </Card>
            </Col>
            <Col sm={9}>
              <div className={"profile" === sectionId ? "" : "hidden"}>
                <Profile
                  history={this.props.history}
                  app={this.props.app}
                  org={this.props.org}
                  blob={this.props.blob}
                  blobInterface={this.props.blobInterface}
                  readOnly={!canAdmin}
                />
              </div>
              <div className={"access" === sectionId ? "" : "hidden"}>
                <Access
                  history={this.props.history}
                  app={this.props.app}
                  profileInterface={{
                    loadProfile: () => {
                      return this.props.blobInterface.loadBlob();
                    }
                  }}
                  target={"blob"}
                  targetObject={this.props.blob}
                />
              </div>
              <div className={"api-keys" === sectionId ? "" : "hidden"}>
                <ApiKeys
                  history={this.props.history}
                  app={this.props.app}
                  target={"blob"}
                  targetId={this.props.blob.id}
                />
              </div>
              <div className={"credentials" === sectionId ? "" : "hidden"}>
                <Credentials
                  history={this.props.history}
                  app={this.props.app}
                  target={"blob"}
                  targetId={this.props.blob.id}
                />
              </div>
              <div className={"limits" === sectionId ? "" : "hidden"}>
                <Limits
                  history={this.props.history}
                  app={this.props.app}
                  org={this.props.org}
                  blob={this.props.blob}
                  target={"blob"}
                  targetIds={[this.props.org.id, this.props.blob.id]}
                />
              </div>
              <div className={"preferences" === sectionId ? "" : "hidden"}>
                <PreferencesEditor
                  scope={{ orgId: this.props.org.id, blobId: this.props.blob.id }}
                  blob={this.props.blob}
                />
              </div>
              <div className={"admin" === sectionId ? "" : "hidden"}>
                <Admin
                  history={this.props.history}
                  app={this.props.app}
                  org={this.props.org}
                  blob={this.props.blob}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
